import { Typography } from "@material-ui/core";
import React from "react";


export function NoMatch() {
    return <Typography variant="h1" component="h2">
        404, Pagina non trovata
    </Typography>
}